import React from "react";
import { Link, NavLink } from "react-router-dom";
import cv from "../assets/images/cv.pdf";
import { BsCloudDownload } from "react-icons/bs";

const Navbar = () => {
  return (
    <section className="lg:mx-4 sticky z-50 top-2 n_box lg:py-4 p-2">
      <div class="navbar bg-primary py-4 lg:px-64 lg:rounded-lg">
        <div class="navbar-start">
          <div class="dropdown">
            <label tabindex="0" class="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabindex="0"
              class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-primary rounded-box w-52"
            >
              <li>
                <NavLink className="lg:px-6" to="/">
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink className="lg:px-6" to={"/about"}>
                  About
                </NavLink>
              </li>
              <li>
                <NavLink className="lg:px-6" to={"/contact"}>
                  Contact
                </NavLink>
              </li>
              <li>
                <NavLink className="lg:px-6" to={"/blogs"}>
                  Blogs
                </NavLink>
              </li>
              <li>
                <NavLink
                  to={cv}
                  target="_blank"
                  className="font-bold text-xs btn text-base-100 btn-outline btn-secondary rounded-full"
                  download
                >
                  Download Resume
                  <BsCloudDownload className="text-xl hover:text-2xl" />
                </NavLink>
              </li>
            </ul>
          </div>
          <Link
            to={"/"}
            class="btn lg:border-l-2 rounded-none text-center md:text-left lg:text-lg lg:border-l-secondary btn-ghost normal-case md:text-3xl text-xl lg:text-4xl text-base-100 tracking-widest font-semibold"
          >
            Md.Kibria
          </Link>
        </div>
        <div class="navbar-end font-medium tracking-widest hidden lg:flex">
          <ul class="menu menu-horizontal text-lg p-0">
            <li>
              <NavLink className="lg:px-6" to="/">
                Home
              </NavLink>
            </li>
            <li>
              <NavLink className="lg:px-6" to={"/about"}>
                About
              </NavLink>
            </li>
            <li></li>
            <li>
              <NavLink className="lg:pr-10" to={"/contact"}>
                Contact
              </NavLink>
            </li>
            <li>
              <NavLink className="lg:px-6" to={"/blogs"}>
                Blogs
              </NavLink>
            </li>
            <li>
              <NavLink
                to={cv}
                target="_blank"
                className="font-bold ml-4 btn text-base-100 btn-outline btn-secondary rounded-full"
                download
              >
                Download Resume
                <BsCloudDownload className="text-xl hover:text-2xl" />
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Navbar;
